module.exports = __webpack_public_path__ + "img/ts5.fbe86456.png";